/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EodMelcoEodModelsEodLog,
    EodMelcoEodModelsEodLogFromJSON,
    EodMelcoEodModelsEodLogFromJSONTyped,
    EodMelcoEodModelsEodLogToJSON,
    EodMelcoModelsCustomWarning,
    EodMelcoModelsCustomWarningFromJSON,
    EodMelcoModelsCustomWarningFromJSONTyped,
    EodMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EodMelcoModelsGenericList1MelcoEodModelsEodLog
 */
export interface EodMelcoModelsGenericList1MelcoEodModelsEodLog {
    /**
     * 
     * @type {Array<EodMelcoEodModelsEodLog>}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsEodLog
     */
    list: Array<EodMelcoEodModelsEodLog>;
    /**
     * 
     * @type {Array<EodMelcoModelsCustomWarning>}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsEodLog
     */
    warning_list?: Array<EodMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsEodLog
     */
    total: number;
}

export function EodMelcoModelsGenericList1MelcoEodModelsEodLogFromJSON(json: any): EodMelcoModelsGenericList1MelcoEodModelsEodLog {
    return EodMelcoModelsGenericList1MelcoEodModelsEodLogFromJSONTyped(json, false);
}

export function EodMelcoModelsGenericList1MelcoEodModelsEodLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoModelsGenericList1MelcoEodModelsEodLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EodMelcoEodModelsEodLogFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EodMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EodMelcoModelsGenericList1MelcoEodModelsEodLogToJSON(value?: EodMelcoModelsGenericList1MelcoEodModelsEodLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EodMelcoEodModelsEodLogToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EodMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


